import React from 'react'
import { Route } from 'react-router-dom'

import EntregaMenu from './EntregaMenu/EntregaMenu'
import CicloEntrega from './CicloEntrega/CicloEntrega'
import ImportacaoCicloEntrega from './ImportacaoCicloEntrega/ImportacaoCicloEntrega'
import Trecho from './Trecho/Trecho'
import TransferenciaEntrega from './TransferenciaEntrega/TransferenciaEntrega'
import TransferenciaAssocEntrega from './TransferenciaAssocEntrega/TransferenciaAssocEntrega'
import CarregamentoVeiculo from './CarregamentoVeiculo/CarregamentoVeiculo'
import RecebimentoTransferencia from './RecebimentoTransferencia/RecebimentoTransferencia'

import { auth } from '../../../services/util/auth.service'
import EnvioParaRota from './EnvioParaRota/EnvioParaRota'
import RetornoVeiculo from './RetornoVeiculo/RetornoVeiculo'
import RetornoVeiculoApuracao from './RetornoVeiculoApuracao/RetornoVeiculoApuracao'
import ImportacaoRoteiro from './ImportacaoRoteiro/ImportacaoRoteiro'
import Canhoto from './Canhoto/Canhoto'
import Faltas from './Ocorrencias/Falta/Index'
import Sobras from './Ocorrencias/Sobra/Index'
import EntregasPorEmpresa from './EntregasPorEmpresa/EntregasPorEmpresa'
import EntregaDetalhes from './EntregaDetalhes/EntregaDetalhes'
import ImportacaoCicloEntregaXml from './ImportacaoCicloEntregaXml/ImportacaoCicloEntregaXml'
import EntregasParaRoteirizacao from './EntregasParaRoteirizacao/EntregasParaRoteirizacao'
import ClientesSemTrecho from './Trecho/ClientesSemTrecho/ClientesSemTrecho'
import EnderecamentoDasEntregas from './EnderecamentoDasEntregas/EnderecamentoDasEntregas'
import RoteirizacaoPreviaDasEntregas from './RoteirizacaoPreviaDasEntregas/RoteirizacaoPreviaDasEntregas'
import RoteirizacaoAssocEntregas from './RoteirizacaoPreviaDasEntregas/RoteirizacaoAssocEntregas'
import RoteirizarEntregas from './RoteirizacaoPreviaDasEntregas/RoteirizarEntregas'
import CicloEntregaAcoes from './CicloEntregaAcoes.js/CicloEntregaAcoes'
import ImportacaoCicloEntregaPdf from './ImportacaoCicloEntregaPdf/ImportacaoCicloEntregaPdf'
import ImportacaoCicloEntregaEdi from './ImportacaoCicloEntregaEdi/ImportacaoCicloEntregaEdi'
import ImportacaoCicloEntregaRtf from './ImportacaoCicloEntregaRtf/ImportacaoCicloEntregaRtf'
import MultiploCicloEntrega from './MultiploCicloEntrega/MultiploCicloEntrega'
import ImportacaoMultiploCicloEntrega from './MultiploCicloEntrega/ImportacaoMultiploCicloEntrega/ImportacaoMultiploCicloEntrega'
import MapaCarga from './MapaCarga/MapaCarga'
import RastreabilidadePallet from './RastreabilidadePallet/RastreabilidadePallet'
import MapaCargaAnalitico from './MapaCargaAnalitica/MapaCargaAnalitico'
import MapaCarregamento from './CarregamentoVeiculo/MapaCarregamento/MapaCarregamento'
import RoteirizacaoAutomatica from './CarregamentoVeiculo/RoteirizacaoAutomatica/RoteirizacaoAutomatica'
import ImportarApuracao from './RetornoVeiculo/ImportarApuracao'
import InformacoesHorarioSaida from './InformacoesHorarioSaida/InformacoesHorarioSaida'
import JustificativaCargasParadas from './JustificativaCargasParadas/JustificativaCargasParadas'
import GestaoCanhoto from './GestaoCanhoto/GestaoCanhoto'
import EntregaSemCanhoto from './GestaoCanhoto/EntregaSemCanhoto'
import EntregaComCanhoto from './GestaoCanhoto/EntregaComCanhoto'
import GestaoCtes from './Cte/GestaoCtes'
import EmissaoCte from './Cte/EmitirCte/EmissaoCte'
import EmissaoCteGlobalizado from './Cte/EmissaoCteGlobalizado/EmissaoCteGlobalizado'
import EmissaoCteSubcontratacao from './Cte/EmissaoCteSubcontratacao/EmissaoCteSubcontratacao'
import GestaoMdfes from './Mdfe/GestaoMdfes'
import GestaoCiot from './Ciot/GestaoCiot'
import ImportacaoMultiCicloEntregaXml from './ImportacaoMultiCicloEntregaXml/ImportacaoMultiCicloEntregaXml'
import ListagemTagPallet from './ListagemTagPallet/ListagemTagPallet'
import CargasParadasTransferencia from './CargasParadasTransferencia/TransferenciaAssocEntrega/CargasParadasTransferencia'
import GeoposicionamentoVeiculo from './GeoposicionamentoVeiculo/GeoposicionamentoVeiculo'
import BateriaCelularDrive from './BateriaCelularDrive/BateriaCelularDrive'
import VeiculosRetornados from './VeiculosRetornados/VeiculosRetornados'
import VeiculosRetornadosApuracao from './VeiculosRetornados/VeiculosRetornadosApuracao'
import ChatClient from './ChatClient/ChatClient'
import AgendamentoEntrega from './JustificativaCargasParadas/AgendamentoEntrega/AgendamentoEntrega'
import GerarOcorren from './GerarOcorren/GerarOcorren'
import LogsXmlRobot from './LogsXmlRobot/LogsXmlRobot'

export default function Entrega() {
  return (
    <React.Fragment>
      <Route path="/main/entregas/menu" render={() => auth(<EntregaMenu />)} />
      <Route path="/main/entregas/ciclo-entrega" render={() => auth(<CicloEntrega />, 75)} />
      <Route
        path="/main/entregas/importacao-ciclo-entrega"
        render={() => auth(<ImportacaoCicloEntrega />, 75)}
      />
      <Route
        path="/main/entregas/importacao-ciclo-entrega-xml"
        render={() => auth(<ImportacaoCicloEntregaXml />, 75)}
      />
      <Route
        path="/main/entregas/importacao-ciclo-entrega-pdf"
        render={() => auth(<ImportacaoCicloEntregaPdf />, 75)}
      />
      <Route
        path="/main/entregas/importacao-ciclo-entrega-edi"
        render={() => auth(<ImportacaoCicloEntregaEdi />, 75)}
      />
      <Route
        path="/main/entregas/importacao-ciclo-entrega-rtf"
        render={() => auth(<ImportacaoCicloEntregaRtf />, 75)}
      />
      <Route
        path="/main/entregas/importacao-multi-ciclo-entrega-xml"
        render={() => auth(<ImportacaoMultiCicloEntregaXml />, 75)}
      />
      <Route path="/main/entregas/trechos" render={() => auth(<Trecho />, 75)} />
      <Route
        path="/main/entregas/clientes-sem-trechos"
        render={() => auth(<ClientesSemTrecho />, 75)}
      />
      <Route
        path="/main/entregas/ciclo-entrega-acoes"
        render={() => auth(<CicloEntregaAcoes />, 75)}
      />
      <Route
        path="/main/entregas/transferencia-entrega"
        render={() => auth(<TransferenciaEntrega />, 76)}
      />
      <Route
        path="/main/entregas/recebimento-transferencia-entrega"
        render={() => auth(<RecebimentoTransferencia />, 77)}
      />
      <Route
        path="/main/entregas/transferencia-assoc-entrega"
        render={() => auth(<TransferenciaAssocEntrega />, 76)}
      />
      <Route
        path="/main/entregas/cargas-paradas-transferencia"
        render={() => auth(<CargasParadasTransferencia />, 76)}
      />
      <Route
        path="/main/entregas/carregamento-veiculos"
        render={() => auth(<CarregamentoVeiculo />, 78)}
      />
      <Route
        path="/main/entregas/importacao-roteiro"
        render={() => auth(<ImportacaoRoteiro />, 78)}
      />
      <Route path="/main/entregas/enviar-veiculos" render={() => auth(<EnvioParaRota />, 81)} />
      <Route path="/main/entregas/retornar-veiculos" render={() => auth(<RetornoVeiculo />, 82)} />
      <Route
        path="/main/entregas/geoposicionamento"
        render={() => auth(<GeoposicionamentoVeiculo />)}
      />
      <Route path="/main/entregas/bateria-celular" render={() => auth(<BateriaCelularDrive />)} />
      <Route
        path="/main/entregas/retorno-veiculo-apuracao"
        render={() => auth(<RetornoVeiculoApuracao />, 82)}
      />
      <Route path="/main/entregas/anexar-canhoto" render={() => auth(<Canhoto />)} />
      <Route path="/main/entregas/ocorrencias/sobras" render={() => auth(<Sobras />)} />
      <Route path="/main/entregas/ocorrencias/faltas" render={() => auth(<Faltas />)} />
      <Route
        path="/main/entregas/entrega-por-empresa-analitico"
        render={() => auth(<EntregasPorEmpresa />, 83)}
      />
      <Route path="/main/entregas/entrega-detalhes" render={() => auth(<EntregaDetalhes />)} />
      <Route
        path="/main/entregas/entrega-para-roteirizacao"
        render={() => auth(<EntregasParaRoteirizacao />, 84)}
      />
      <Route
        path="/main/entregas/enderecamento-das-entregas"
        render={() => auth(<EnderecamentoDasEntregas />, 85)}
      />
      <Route
        path="/main/entregas/roteirizacao-previa-das-entregas"
        render={() => auth(<RoteirizacaoPreviaDasEntregas />, 86)}
      />
      <Route
        path="/main/entregas/roteirizacao-assoc-entregas"
        render={() => auth(<RoteirizacaoAssocEntregas />, 86)}
      />
      <Route
        path="/main/entregas/roteirizacao-roteirizar-entregas"
        render={() => auth(<RoteirizarEntregas />, 86)}
      />
      <Route
        path="/main/entregas/multiplo-ciclo-entrega"
        render={() => auth(<MultiploCicloEntrega />, 30)}
      />
      <Route
        path="/main/entregas/importacao-multiplo-ciclo-entrega"
        render={() => auth(<ImportacaoMultiploCicloEntrega />, 30)}
      />
      <Route path="/main/entregas/mapa-de-carga" render={() => auth(<MapaCarga />, 79)} />
      <Route
        path="/main/entregas/mapa-de-carga-analitico"
        render={() => auth(<MapaCargaAnalitico />, 80)}
      />
      <Route
        path="/main/entregas/rastreabilidade-pallet"
        render={() => auth(<RastreabilidadePallet />, 87)}
      />
      <Route
        path="/main/entregas/mapa-carregamento"
        render={() => auth(<MapaCarregamento />, 78)}
      />
      <Route
        path="/main/entregas/roteirizacao-automatica"
        render={() => auth(<RoteirizacaoAutomatica />, 78)}
      />
      <Route path="/main/entregas/importa-apuracao" render={() => auth(<ImportarApuracao />, 82)} />
      <Route
        path="/main/entregas/informacoes-horario-saida"
        render={() => auth(<InformacoesHorarioSaida />, 88)}
      />
      <Route
        path="/main/entregas/justificativa-cargas-paradas"
        render={() => auth(<JustificativaCargasParadas />, 89)}
      />
      <Route path="/main/entregas/gestao-canhotos" render={() => auth(<GestaoCanhoto />, 90)} />
      <Route
        path="/main/entregas/gestao-canhotos-sem-canhoto"
        render={() => auth(<EntregaSemCanhoto />, 90)}
      />
      <Route
        path="/main/entregas/gestao-canhotos-com-canhoto"
        render={() => auth(<EntregaComCanhoto />, 90)}
      />
      <Route path="/main/entregas/gestao-ctes" render={() => auth(<GestaoCtes />, 40)} />
      <Route path="/main/entregas/emissao-ctes" render={() => auth(<EmissaoCte />, 40)} />
      <Route
        path="/main/entregas/emissao-cte-globalizado"
        render={() => auth(<EmissaoCteGlobalizado />, 94)}
      />
      <Route
        path="/main/entregas/emissao-cte-subcontratacao"
        render={() => auth(<EmissaoCteSubcontratacao />, 40)}
      />
      <Route path="/main/entregas/gestao-mdfes" render={() => auth(<GestaoMdfes />, 91)} />
      <Route path="/main/entregas/gestao-ciots" render={() => auth(<GestaoCiot />, 91)} />
      <Route
        path="/main/entregas/listagem-tag-pallet"
        render={() => auth(<ListagemTagPallet />, 92)}
      />
      <Route
        path="/main/entregas/veiculos-retornados"
        render={() => auth(<VeiculosRetornados />, 93)}
      />
      <Route
        path="/main/entregas/veiculos-retornados-apuracao"
        render={() => auth(<VeiculosRetornadosApuracao />, 93)}
      />
      <Route path="/main/entregas/chat" render={() => auth(<ChatClient />)} />
      <Route
        path="/main/entregas/agendamento-entrega"
        render={() => auth(<AgendamentoEntrega />, 89)}
      />
      <Route path="/main/entregas/gerar-ocorren" render={() => auth(<GerarOcorren />, 83)} />
      <Route path="/main/entregas/logs-xml-robot" render={() => auth(<LogsXmlRobot />, 75)} />
    </React.Fragment>
  )
}
